export class EventBus {

    private queue = {};
    private listeners = {};

    constructor() {
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('hdEventBusInit'));
        }, 0);
    }

    public emit(event: string, payload: any) {
        if (this.listeners[event]) {
            this.listeners[event](payload);
        } else {
            if (!this.queue[event]) {
                this.queue[event] = [];
            }
            if ((typeof payload === 'string' || typeof payload === 'number')
                && !!this.queue[event].find(eventPayload => eventPayload === payload)) {
                return;
            }
            this.queue[event].push(payload);
        }
    }

    public on(event: string, callback) {
        this.consumeQueue(event, callback);
        this.listeners[event] = callback;
    }

    private consumeQueue(event: string, callback) {
        if (!this.queue[event]) {
            return;
        }
        while (this.queue[event].length > 0) {
            const payload = this.queue[event].shift();
            callback(payload);
        }
    }

}